import Vue from 'vue'
import App from '@/App'
import store from '../store'
import 'animate.css'
import '../styles/base.sass'
import Router from 'vue-router'
import route_conf from '@/router/A'
// import axios from 'axios'

Vue.use(Router)

// axios.get('./static/A/A1/config.json').then((data)=>{
    // console.log(data.data)
    // window.configdata=data.data
    const router = new Router({
        routes:[
            ...route_conf
        ]
    })
    
    Vue.config.productionTip = false
    
    router.addRoutes([{
        path: '/', redirect: '/A/A3' 
    }])
    
    
    new Vue({
    store, router,
    render: h => h(App),
    components:{App}
    }).$mount('#app')
// })




